export default __webpack_public_path__ + "static/media/BGC-login-icon.9ffaac1f.svg";